/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Collection({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M.4 6.446V3A1.6 1.6 0 0 1 2 1.4h3.063a1.6 1.6 0 0 1 1.6 1.564h4.243c1.216 0 2.233.855 2.48 1.997A2.6 2.6 0 0 1 15.6 7.532v4.47a2.6 2.6 0 0 1-2.6 2.6H3a2.6 2.6 0 0 1-2.6-2.6V6.445Zm1.2-1.514h10.517a1.338 1.338 0 0 0-1.21-.768H6.093l-.031-.001a.6.6 0 0 1-.6-.6V3a.4.4 0 0 0-.4-.4H2a.4.4 0 0 0-.4.4v1.932Zm0 7.07v-5.87H13a1.4 1.4 0 0 1 1.4 1.4v4.47a1.4 1.4 0 0 1-1.4 1.4H3a1.4 1.4 0 0 1-1.4-1.4Z" clipRule="evenodd" /></svg>;
}
;